<template>
  <div class="container-fluid mb-4 pb-4">

 <div class="container-fluid no-gutters">
      <img  src="@/assets/images/cooperation/carousel/1.png"
           class="img-fluid rounded" alt="...">
    </div>
    <!-- <div class="container-fluid">
      <carousel :interval="3000" :per-page="1" :autoplay="true" :loop="true">
        <slide v-for="(image,index) in carouselList" :key="index">
          <img class="w-100 h-100" :src="require(`@/assets/images/cooperation/carousel/${image.path}.png`)" alt="">
        </slide>
      </carousel>
    </div> -->

    <div class="container-fluid pb-4 align-items-start align-content-center justify-content-center"
         style="background-color: #F2F6FF;">
      <div class="row justify-content-center pt-4">
        <div class="col-md-9 mt-3">
          <h2 class="mt-4 pt-4 boldText">{{ $t("h.coo_hi") }}</h2>
        </div>
        <div class="col-md-9 text-left mt-3 pl-4">
          <div class="px-2 pb-1"><p class="font-class-ref text-black-50">{{ $t("h.coo_hi_info") }}</p>
          </div>
          <img style="border-radius: 15px;" src="../assets/images/cooperation/line.png" alt="" class="w-100 mt-2">
        </div>
      </div>

      <div class="container ">
        <div class="row justify-content-center py-4">
          <!--        <div class="col-md-9 my-3 d-flex pb-3">-->
          <div class="col-md-5 text-left my-auto ">
            <h3  class="mb-4 font-weight-bold boldText join-phone">{{ $t("h.coo_join") }}</h3>
            <p class="font-class-ref text-black-50 mt-3">{{ $t("h.coo_join_info") }}</p>
          </div>
          <div class="col-md-5">
            <img class="img-fluid" src="../assets/images/cooperation/image.png" alt="">
          </div>
          <!--        </div>-->
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row justify-content-center equal-height mt-4  ">
        <div style="padding-bottom: 2rem !important;border-radius: 15px;" class="col-md-3 mx-2 bg-light my-4 text-left p-4"  v-for="(item,index) in cards" :key="index">
            <img src='../assets/images/cooperation/shape.png' class="my-2 img-fluid" style="width: 5vh; height: 5vh" >
            <div class="position-class" >
              <h5 class="font-weight-bold py-2 boldText">{{ $t(`h.position_title${index + 1}`) }}</h5>
            </div>
            <div  class="text-left mb-md-0" v-for="(i,index2) in item.items" :key="index2">
              <div  class="font-weight-bold my-2  pt-3  font-class-ref">{{ $t(`h.position_item_title${index + 1}_${index2 + 1}`) }}</div>
              <div class="mb-md-0" v-for="(j,index3) in i.itemContent" :key="index3">
                 <p class="mb-md-0 position-font-class-ref"> <span style="color:blue;">•</span>  {{ $t(`h.position_item_content${index + 1}_${index2 + 1}_${index3 + 1}`) }} </p>
              </div>
            </div>
        </div>
      </div>
    </div>
    
    <!-- 第五部分 -->
  <div class=" row justify-content-center equal-height " >
 <div class="col-md-9  bg-light  text-left p-4 cooSummery " style="    border-radius: 15px 15px 0 0;
">
    {{$t('h.coo_summery2')}}  </div>
     <div class="col-md-9  bg-light  text-left p-4 cooSummery " style="    border-radius:  0 0 15px 15px;
">
        {{ $t("h.coo_summery") }}
      </div>
    </div>

    <div style="maright-top:30px;" class="row justify-content-center mt-4">
      <div class="col-md-9 mt-4">
        <h4 class="font-weight-bold my-4 pb-2 pt-4 boldText">{{ $t("h.coo_form_title") }}</h4>
        <div class="text-left px-3 mt-4 pt-2" >
          <!-- <div class="row justify-content-between">
            <span class="pl-3 text-black-50 font-class-ref ">{{ $t("h.coo_website_info") }}</span>
            <span class="text-black-50 font-class-ref ">{{ $t("h.coo_email") }}</span>
            <span class="text-black-50 font-class-ref ">{{ $t("h.coo_phone") }}</span>
          </div> -->
           <p class="text-black-50 font-class-ref ">{{ $t("h.coo_website_info") }}</p>
            <p class="text-black-50 font-class-ref ">{{ $t("h.coo_email") }}</p>
             <p class="text-black-50 font-class-ref ">{{ $t("h.coo_phone") }}</p>
          <p class="text-black-50 font-class-ref ">{{ $t("h.coo_address") }}</p>
        </div>
      </div>
    </div>

    <!-- <div class="row justify-content-center mb-4">
      <div class="col-md-9 my-3 three-svc">
        <div class="row justify-content-center mb-4">
          <div style="font-size:30px;" class="col-md-8 my-4 pb-2 pt-2 text-black-50 boldText">{{ $t("h.coo_form_info") }}
          </div>
          <div class="col-md-10">
            <form @submit.prevent="submitForm" class="mb-3">
              <div class="form-row">
                <div class="col-6">
                  <input type="text" class="form-control" :placeholder="$t('h.coo_first_name')"
                         v-model="formData.firstName"
                         required>
                </div>
                <div class="col-6">
                  <input type="text" class="form-control" :placeholder="$t('h.coo_last_name')"
                         v-model="formData.LastName" required>
                </div>
                <div class="col-6 my-3">
                  <input type="email" class="form-control" :placeholder="$t('h.coo_your_email')"
                         v-model="formData.email" required>
                </div>
                <div class="col-6 my-3">
                  <input type="text" class="form-control" :placeholder="$t('h.coo_your_phone')"
                         v-model="formData.phoneNumber"
                         required>
                </div>
              </div>
              <div class="form-group">
                <textarea class="form-control" rows="3" :placeholder="$t('h.coo_your_message')"
                          v-model="formData.message"
                          required></textarea>
              </div>
              <button type="submit" style="width: 33%;border-radius: 4vh;" class="btn btn-primary my-3 form-control">
                {{ $t("h.submit") }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div> -->

    <div class="container">
      <b-modal id="modal-1" ref="successModal" hide-footer hide-header title="">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 d-flex align-items-center justify-content-center" style="height: 100%;">
              <div class="d-flex flex-column align-items-center">
                <img src="@/assets/images/cooperation/success.png" alt="Success Icon"
                     class="mx-auto d-block success-icon" style="width: 50px; height: 50px;">
                <p class="text-center mt-3">{{ $t("h.success") }}</p>
                <button type="button" class="btn btn-primary mt-3" style="width: 20vw; border-radius: 20px"
                        @click="closeModal">{{ $t("h.confirm") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {positionList_zh} from "@/constant/zh/positions";

const fs = require('fs');
const path = require('path');

export default {
  name: 'Cooperation',
  data() {
    return {
      formData: {
        firstName: '',
        LastName: '',
        email: '',
        phoneNumber: '',
        message: ''
      },
      cards: positionList_zh,
      carouselList: [
       
        {
          path: "2",
          title: "2",
          alt: "...",
        } ,
        {
          path: "1",
          title: "1",
          alt: "...",
        }
      ],
    };
  },
  methods: {
   
    async saveData(formData) {
      const today = this.$moment().format('YYYY-MM-DD')
      const dirPath = path.join('/opt', today);
      const filePath = path.join(dirPath, 'data.json');

      // 检查文件夹是否存在，不存在则创建
      if (!fs.existsSync(dirPath)) {
        fs.mkdirSync(dirPath, {recursive: true});
      }

      // 将formData转换为JSON字符串
      const dataString = JSON.stringify(formData, null, 2) + '\n';

      // 追加到文件
      await fs.promises.appendFile(filePath, dataString);

      this.formData = {
        firstName: '',
        LastName: '',
        email: '',
        phoneNumber: '',
        message: ''
      }
    },
    submitForm() {
      this.saveData(this.formData)
      this.showSuccessModal()
    },
    showSuccessModal() {
      this.$refs.successModal.show();
    },
    closeModal() {
      this.$refs.successModal.hide();
    }
  },
  mounted() {
    // 等待DOM渲染完成
    this.$nextTick(() => {

    });
  }
};
</script>

<style scoped>
@media (min-width: 1200px) {
    .container-xl, .container-lg, .container-md, .container-sm, .container {
        max-width: 90%;
    }
}
.cooSummery{
  font-size: 35px;
}
.form-control{
  font-size: 22px
  
  
}
.form-control::placeholder {
  color: #d8d4d4; /* 浅灰色，可以根据需要调整 */
  opacity: 1; /* 确保颜色设置生效 */
}
.boldText{
  font-size: 40px;
    font-weight: 700;
}
.bg-cooperation-image-container {
  /* 确保容器有足够的高度来显示背景图片 */
  height: 90vh !important; /* 或者使用 100vh, 100%, 等，根据你的需求来定 */
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 255, 1)),
  url('../assets/images/culture/cul-welcome.png');
  background-size: auto; /* 保持图片的原始大小 */
  background-position: center; /* 图片居中 */
  background-repeat: no-repeat; /* 不重复背景图片 */
  /* 确保渐变和图片一起滚动（如果需要的话） */
  background-attachment: scroll;
}

.three-svc {
  background-color: rgba(242, 242, 242);
}

.container-fluid {
  padding: 0;
}


/*默认字体大小*/
/*默认字体大小*/
.font-class-ref {
  font-size: 1.2vw
}

.font-class-ref-1 {
  font-size: 1.2vw
}


.position-font-class-ref {
  font-size: 1.3vw
}


/* 等高 */
.row.equal-height {
  display: flex;
  flex-wrap: wrap;
}

.row.equal-height > [class^="col-"] {
  display: flex;
  flex-direction: column;
}

.row.equal-height .card {
  flex: 1 1 100%; /* Flex grow, shrink, basis */
  display: flex;
  flex-direction: column;
}

.row.equal-height .card-body {
  flex: 1 1 auto; /* This ensures the card-body expands to fill the card */
}

/* .position-class {
  height: 10vh;
} */
 .join-phone{
  text-align: center;
}

@media (max-width: 768px) {
  
    .equal-height{
    padding: 0 10px;
  }
  .cooSummery{
  font-size: 20px;
}
    .form-control{
  font-size: 20px
}
   .boldText{
    font-size: 30px;
  }
  .font-class-ref {
    font-size: 1.7vw
  }
  .container-fluid {
  padding: 5px;
}
}

@media (max-width: 567px) {
.join-phone{
  text-align: center;
}
  
  .equal-height{
    padding: 0 10px;
  }
  .cooSummery{
  font-size: 20px;
}
  .form-control{
  font-size: 20px
}
   .boldText{
    font-size: 30px;
  }
   .font-class-ref {
    font-size: 5vw;
    margin: 1em;
  }

  /* .position-class {
    height: 3vh;
  } */

  .position-font-class-ref {
    font-size: 4vw
  }
    .container-fluid {
  padding: 5px;
}
}

</style>